import DatePicker from '../../../shared/DatePicker'
import CustomButton from '../../../shared/CustomButton'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import DropdownField from '../../../shared/DropdownField'
import { useDispatch, useSelector } from 'react-redux'
import { getDepartmentList } from '../../../services/ApiMethods'
import { useEffect, useState } from 'react'
import { getPayersList } from '../../../redux/slices/VisitsSlice'
import { fetchData } from '../../../helpers/fetchData'
import { practionerOptionsFormat } from '../../../constants/VisitsConstants'
import { payersOptionsFormat } from '../../../constants/BeneficiaryConstants'
import TextInput from '../../../shared/TextInput'
import { validateOneMonthRange, getMinDate, getOneMonthMaxDate } from '../../../utils/dateRangeValidation'

function Filters({
  payloadData,
  setPayloadData,
  requestReport,
  responseReport,
  insturance = false,
  ItemWiseSummaryReport = false
}) {
  const { t } = useTranslation()
  const [practitonerLoading, setPractitionerLoading] = useState(false)
  const [fieldsLoading, setFieldsLoading] = useState(false)
  const [practionersList, setPractionersList] = useState([])
  const [departmentsList, setDepartmentsList] = useState([])
  const dispatch = useDispatch()
  const handleChange = event => {
    const { name, value } = event.target || {}
    
    if (name === 'department_id' && value && !ItemWiseSummaryReport) {
      getPractitionerListData(value);
    }

    if (name === 'payer_id' && value && insturance) {
      const selectedPayer = payersData?.data?.find(payer => payer.payer_id === value)
      const payerCategory = selectedPayer?.category || 'insurance'
      
      setPayloadData(prevValues => ({
        ...prevValues,
        [name]: value,
        category: payerCategory
      }))
    } else if (name === 'payer_id' && !value && insturance) {
      setPayloadData(prevValues => ({
        ...prevValues,
        [name]: value,
        category: 'insurance'
      }))
    } else {
      setPayloadData(prevValues => ({
        ...prevValues,
        [name]: value,
      }))
    }
  }
  const { payersData, isLoading: isLoadingPayers } = useSelector(
    (state) => state?.visits
  );
  const handleApply = async () => {
    if (!validateOneMonthRange(payloadData?.start_date, payloadData?.end_date, t)) return
    await requestReport(payloadData)
  }

  const handleReset = async () => {
    const payload = {
      end_date: moment().toDate(),
      start_date: moment().subtract(1, 'day').toDate(),
      practitioner: '',
      department_id: '',
      payer_id: '',
      invoice_number: '',
    }
    setPayloadData(payload)
    await requestReport(payload, payload?.filters?.status)
  }

  useEffect(() => {
    if (!insturance) {
      getDepartmentList(setFieldsLoading, setDepartmentsList);
    }
    dispatch(getPayersList())
  }, []);

  const getPractitionerListData = async (dep_name) => {
    setPractitionerLoading(true);
    const response = await fetchData(
      "POST",
      `/v3/practitioner/getByDepartmentId?department_id=${dep_name}`,
      {}
    );
    setPractitionerLoading(false);
    let formatedData = response?.practitioners
      ? practionerOptionsFormat(response?.practitioners)
      : [];
    setPractionersList(formatedData);
  };


  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex  items-center gap-2">
        <DatePicker
          name="start_date"
          useFormik={false}
          className="mt-1"
          value={payloadData?.start_date}
          onChange={handleChange}
          placeholder={t('Selectstartdate')}
          format="YYYY-MM-DD"
        />

        <DatePicker
          name="end_date"
          useFormik={false}
          className="mt-1"
          value={payloadData?.end_date}
          onChange={handleChange}
          placeholder={t('Selectenddate')}
          format="YYYY-MM-DD"
          minDate={getMinDate(payloadData?.start_date)}
          maxDate={getOneMonthMaxDate(payloadData?.start_date)}
        />

        {!insturance ? (
          <>
            <DropdownField
              parentClass="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2"
              placeholder={`${t('Select department')}`}
              name="department_id"
              filter
              useFormik={false}
              options={departmentsList}
              optionLabel="name_en"
              optionValue="id"
              value={payloadData?.department_id}
              onChange={handleChange}
            />
            {!ItemWiseSummaryReport && <DropdownField
              parentClass="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2"
              placeholder={`${t('Select practitioner')}`}
              name="practitioner"
              filter
              useFormik={false}
              options={practionersList}
              value={payloadData?.practitioner}
              onChange={handleChange}
              loading={practitonerLoading}
              disabled={practitonerLoading}

            />}
          </>
        ) : (
          <DropdownField
            parentClass="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2"
            placeholder={`${t('Select payer')}`}
            name="payer_id"
            filter
            useFormik={false}
            options={payersOptionsFormat(payersData?.data)}
            value={payloadData?.payer_id}
            onChange={handleChange}
          />
        )}

        {insturance && (
          <TextInput
            name="invoice_number"
            value={payloadData?.invoice_number || ''}
            handleChange={handleChange}
            placeholder={t('Invoice Number')}
            useFormik={false}
            parentClass="!mb-0"
          />
        )}
      </div>

      <div className="flex items-center gap-2 ml-auto">
        <CustomButton
          //label={t('ApplyFilters')}
          title={t('ApplyFilters')}
          buttonType="primary"
          icon="pi pi-filter"
          className="w-fit h-[35px]"
          onClick={handleApply}
        // disabled={payloadData.license_id === ''}
        />
        <CustomButton
          //label={t('Reset')}
          title={t('Reset')}
          buttonType="reset"
          icon="pi pi-sync"
          className="w-fit h-[35px]"
          onClick={handleReset}
        />
      </div>
    </div>
  )
}

export default Filters
